import { defineRouting } from 'next-intl/routing';

// Stage 3b: locales expanded to ['en', 'ar']. Stage 0 was locked to ['en'] only.
// All locales documented in the spec must be added here when their messages files exist.
export const routing = defineRouting({
  locales: ['en', 'ar'],
  defaultLocale: 'en',
  localePrefix: 'as-needed',
  localeDetection: true,
  localeCookie: {
    name: 'SIGNALYNC_LOCALE',
    maxAge: 60 * 60 * 24 * 365,
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
  },
});

export type AppLocale = (typeof routing.locales)[number];
